import { Component, Input } from '@angular/core';
import { IBiAnchorPopup } from "bi-interfaces";

@Component({
  selector: 'bi-anchor-popup',
  templateUrl: './bi-anchor-popup.component.html',
  styleUrls: ['./bi-anchor-popup.component.scss']
})
export class BiAnchorPopupComponent implements IBiAnchorPopup {
  @Input() Width: string = "200px";
  @Input() Height: string = "200px";
  public toggleText = "Hide";
  public show = false;
  
  public onToggle(): void {
    this.show = !this.show;
    this.toggleText = this.show ? "Hidе" : "Show";
  }
}
